import React from 'react'
import './experience.css'
import {BsArrowUpRight} from 'react-icons/bs'

const roles = [
  {
    organization: 'CodePath',
    role: 'Tech Fellow',
    dates: 'Aug 2024 - May 2025; rejoined Jan 2026 - Present',
    summary: 'Support Applied AI Engineering and Technical Interview Prep students through live sessions, breakout rooms, study halls, and practical project work.',
    highlights: [
      'Mentored 400+ students across Applied AI Engineering and Technical Interview Prep.',
      'Guided students using tools such as Copilot and Claude Code to build, debug, and iterate on projects.',
      'Facilitated Python problem-solving discussions covering algorithms, data structures, and debugging.'
    ]
  },
  {
    organization: 'Students Assessing Teaching and Learning (SATAL)',
    role: 'Research Intern',
    dates: 'Jan 2023 - Aug 2024',
    summary: 'Contributed to student-feedback research, data organization, intern onboarding, and collaboration with university stakeholders.',
    highlights: [
      'Analyzed 500+ student-instructor interaction records to support feedback across 50+ university courses.',
      'Used Excel formulas and visualizations to organize findings and identify trends.',
      'Helped hire and onboard 10 interns through information sessions, interviews, and training workflows.'
    ]
  }
]

const Experience = () => (
  <section id="experience">
    <h5>Experience</h5>
    <h2>Work that connects people and systems</h2>

    <div className="container experience__container">
      {roles.map((role) => (
        <article className="experience__role" key={role.organization}>
          <div className="experience__heading">
            <div>
              <p className="experience__organization">{role.organization}</p>
              <h3>{role.role}</h3>
            </div>
            <BsArrowUpRight aria-hidden="true" />
          </div>
          <p className="experience__dates">{role.dates}</p>
          <p className="experience__summary">{role.summary}</p>
          <ul className="experience__highlights">
            {role.highlights.map((highlight) => <li key={highlight}>{highlight}</li>)}
          </ul>
        </article>
      ))}
    </div>
  </section>
)

export default Experience
